{
  "title": "Units of Measure",
  "subtitle": "Define the units this company trades in — these fill the Base UOM and Weight UOM pickers on the Material master.",
  "addUom": "Add Unit of Measure",
  "saveUom": "Save Unit",
  "discardChanges": "Cancel",
  "edit": "Edit",
  "delete": "Delete",
  "table": {
    "code": "Code",
    "name": "Name",
    "status": "Status"
  },
  "form": {
    "code": "Code",
    "codeHint": "Short symbol shown on materials and labels, e.g. KG, PCS, BOX. Must be unique.",
    "name": "Name",
    "nameHint": "Full name, e.g. Kilogram, Pieces, Box.",
    "status": "Status",
    "statusHint": "Inactive units stay on existing materials but are no longer offered for new ones.",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "validation": {
      "codeRequired": "Code is required.",
      "nameRequired": "Name is required."
    }
  },
  "deleteUom": {
    "message": "This unit of measure will be removed. A unit already used by any material cannot be deleted — set it to Inactive instead."
  },
  "errors": {
    "generic": "Could not save the unit of measure. Please try again."
  }
}
